<template>
  <div class="yxtbiz-user-selector-position yxt-user-selector-wrap">
    <yxt-tabs
      :drawer-top="drawerTop"
      @tab-click="name => $emit('tab-click', name)"
      v-model="activeName"
    >
      <yxt-tab-pane
        :key="index"
        v-for="(tab, index) in setTabs"
        :name="tab.value"
      >
        <span slot="label">{{ tab.label }}</span>
        <yxt-row class="yxtbiz-user-selector-container" type="flex">
          <template v-if="activeName === tab.value">
            <slot
              v-if="$slots[tab.value]"
              :name="tab.value"
              :ref="tab.value"
              @update="update"
            />
            <component
              v-else
              :targetOrgId="targetOrgId"
              :is="tab.component"
              :functionCode="functionCode"
              :dataPermissionCode="dataPermissionCode"
              :scope="scope"
              v-model="selectedProps[tab.model]"
              :type="tab.model"
              :positionIds="positionIds"
              :gradeIds="gradeIds"
              @update="update"
              @onProcess="onProcess"
              @org-change="orgChange"
            ></component>
          </template>
          <aside class="yxt-user-selection">
            <yxt-scrollbar :fit-height="true">
              <check-list :data="list">
                <template slot-scope="scope">
                  <yxt-tooltip
                    :key="item.id"
                    v-for="item in scope.list"
                    placement="top"
                    effect="dark"
                  >
                    <template slot="content">
                      <yxtbiz-user-name
                        class="yxtbiz-user-selector-tag"
                        :name="item.fullname || item.name"
                      />
                    </template>
                    <yxt-tag
                      @close="deleteItem(item)"
                      class="mr5"
                      size="small"
                      type="info"
                      :disableTransitions="true"
                      style="margin-bottom:5px"
                      closable
                      ><yxt-svg
                        class="mr5 v-mid"
                        width="14px"
                        height="14px"
                        icon-class="person-center"
                      /><span
                        v-if="!isOpenData || item.nodeType === 'userGroup'"
                        class="yxtbiz-user-selector-tag"
                        >{{ item | tag }}</span
                      >
                      <yxtbiz-user-name
                        class="yxtbiz-user-selector-tag"
                        v-else
                        :name="item.fullname"
                      />
                    </yxt-tag>
                  </yxt-tooltip>
                </template>
              </check-list>
            </yxt-scrollbar>
            <yxt-button
              type="text"
              class="yxtbiz-user-clear font-size-12 color-gray-9 hover-primary-6"
              @click="clear"
              :disabled="list.length === 0"
            >
              {{ $t('biz_udp_clear_all') }}
            </yxt-button>
          </aside>
        </yxt-row>
      </yxt-tab-pane>
    </yxt-tabs>
  </div>
</template>

<script>
import Advance from './components/advance';
import CheckList from './components/checkList';
import openDataMixin from '../mixins/openData';

const TYPE = {
  USER: 'persons'
};
const mapType = function() {
  let result = {};
  let resutArray = {};
  Object.values(TYPE).forEach(type => {
    result[type] = {};
    resutArray[type] = [];
  });

  return [result, resutArray];
};

const testType = function(item) {
  return TYPE.USER;
};
export default {
  name: 'YxtbizUserSelectorPosition',
  mixins: [openDataMixin],
  components: {
    Advance,
    CheckList
  },
  props: {
    drawerTop: {
      default: true,
      type: Boolean
    },
    scope: {
      type: Number,
      default: 0
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 0,
      validator(v) {
        return v >= 0;
      }
    },
    groupLimit: {
      type: Number | String,
      default: ''
    },
    targetOrgId: {
      type: String,
      default: ''
    },
    positionIds: {
      type: Array,
      default: () => []
    },
    gradeIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    // 记录组件初始化的原始数据key值
    this.oldObjKeys = [];
    return {
      currentOrgId: '', // 集团版下组件选中的orgId
      selectedObjs: {
        ...mapType()[0],
        total: {} // 所有选中对象
      },
      selectedProps: {
        ...mapType()[1]
      },
      defaultTabs: [
        {
          label: '选择人员',
          value: 'advance',
          component: 'Advance',
          model: TYPE.USER
        }
      ],
      activeName: 'persons',
      // 子组件状态，是否在处理内部数据（用于标记是否在导入用户流程中）
      processing: false,
      // 用于父组件调用，标记当前选人组件在抽屉中是否需要关闭提示，true：需要提示，false：不需要提示
      showTip: false,
      hideDepart: false //  是否隐藏部门选择框
    };
  },
  created() {
    this.data.forEach(val => {
      const item = { ...val };
      this.selectedObjs.total[item.id] = item;
      this.selectedObjs[TYPE.USER][item.id] = item;
      this.selectedProps[TYPE.USER] = Object.values(
        this.selectedObjs[TYPE.USER]
      );
    });
    this.oldObjKeys = Object.keys(this.selectedObjs.total);
  },
  computed: {
    hasLimit() {
      return this.limit !== 0;
    },
    setTabs() {
      return this.defaultTabs;
    },
    list() {
      return Object.values(this.selectedObjs.total);
    }
  },
  methods: {
    getSelected() {
      /* eslint-disable no-undef */
      return new Promise((resolve, reject) => {
        const userIds = Object.keys(this.selectedObjs[TYPE.USER]).map(item => {
          if (this.isOrgSelectAlone) {
            const [id] = item.split('&&');
            return id;
          }
          return item;
        });
        let userSet = new Set(userIds);
        if (this.hasLimit && userSet.size > this.limit) {
          this.showLimitError();
          return;
        }
        const changePersons = Object.values(this.selectedObjs[TYPE.USER]).map(
          item => {
            const params = { ...item };
            if (this.isOrgSelectAlone) params.id = item.oldId;
            return params;
          }
        );
        resolve([...changePersons]);
      });
    },
    orgChange(data) {
      this.currentOrgId = data.orgId;
    },
    splitObj(items) {
      items.forEach(item => {
        const type = testType(item);
        this.selectedObjs.total[item.id] = item;
        this.selectedObjs[type][item.id] = item;
        this.selectedProps[type].push(item);
      });
    },

    deleteItem(item) {
      this.$delete(this.selectedObjs.total, item.id);
      const type = testType(item);
      this.$delete(this.selectedObjs[type], item.id);
      this.$set(
        this.selectedProps,
        type,
        Object.values(this.selectedObjs[type])
      );
      this.emitChange();
    },
    clear() {
      for (let item in this.selectedObjs) {
        this.selectedObjs[item] = {};
      }

      this.emitChange();

      for (let item in this.selectedProps) {
        this.selectedProps[item] = [];
      }
    },

    updateObj(type, items, isAdd) {

      let obj = Object.assign({}, this.selectedObjs[type]);

      items.forEach(item => {
        if (isAdd) {
          obj[item.id] = item;
        } else {
          delete obj[item.id];
        }
      });

      this.$set(this.selectedObjs, type, obj);
      this.selectedProps[type] = Object.values(this.selectedObjs[type]);
      this.emitChange();
    },

    emitChange() {
      const changePersons = Object.values(this.selectedObjs[TYPE.USER]).map(
        item => {
          const params = { ...item };
          return params;
        }
      );
      // 暴露出去的参数，第一个是选人的，第二个是用户组的，第三个是关联动态用户组的
      this.$emit(
        'change',
        changePersons
      );
      this.showTipHandler();
    },

    update(type, items, isAdd) {

      if (!(items instanceof Array)) {
        items = [items];
      }
      let total = Object.assign({}, this.selectedObjs.total);

      items.forEach(item => {
        if (isAdd) {
          total[item.id] = item;
        } else {
          delete total[item.id];
        }
        // 更新相应类型的选中对象
      });

      this.$set(this.selectedObjs, 'total', total);
      this.updateObj(type, items, isAdd);
    },
    showLimitError() {
      this.$alert(
        this.$t('pc_biz_udp_msg_outRange'),
        this.$t('biz_tcm_limitnum', { x: this.limit }),
        {
          confirmButtonText: this.$t('biz_tcm_checkbtn'),
          type: 'error'
        }
      );
    },
    // 子组件处理状态变更
    onProcess(processing) {
      this.processing = processing;
      this.showTipHandler();
    },
    showTipHandler() {
      // 以下情况需要关闭提示：数据发现了变化或者子组件正在处理数据
      this.showTip =
        this.processing ||
        JSON.stringify(this.oldObjKeys) !==
          JSON.stringify(Object.keys(this.selectedObjs.total));
    }
  },
  watch: {
    setTabs: {
      immediate: true,
      handler(v) {
        this.activeName = v[0].value;
      }
    },
    data(v) {
      this.clear();
      this.splitObj(v);
    }
  },
  filters: {
    tag(input) {
      return input.fullname || input.username;
    }
  }
};
</script>

<style lang="scss" scoped>
.autoWidth {
  width: 100% !important;
  max-width: none !important;
}
</style>
